import { css } from 'styled-components';
export default {
    heading: {
        light: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-weight: 500;
      font-style: italic;
    `,
        bold: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: Poppins, Poppins-fallback, sans-serif; 
      font-weight: 700;
      font-style: italic;
    `,
    },
    body: {
        light: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-style: normal;
      font-weight: 300;
      font-optical-sizing: auto;
    `,
        lightItalic: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-weight: 300;
      font-style: italic;
      font-optical-sizing: auto;
    `,
        regular: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-optical-sizing: auto;
    `,
        regularItalic: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-weight: 400;
      font-style: italic;
      font-optical-sizing: auto;
    `,
        medium: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-optical-sizing: auto;
    `,
        mediumItalic: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-weight: 500;
      font-style: italic;
      font-optical-sizing: auto;
    `,
        bold: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-style: normal;
      font-weight: 700;
      font-optical-sizing: auto;
    `,
        boldItalic: css `
      font-family: Inter, Inter-fallback, sans-serif;
      font-weight: 700;
      font-style: italic;
      font-optical-sizing: auto;
    `,
    },
};
